import { cn as e } from "../shared/utils.js";
import { Progress as t } from "./primitive/index.js";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/progress/progress-bar.tsx
function a({ label: a, labelPosition: o = "top", max: s = 100, rootProps: c, value: l = 0, valueLabel: u, indicatorProps: d, labelProps: f, trackProps: p, valueProps: m }) {
	let { className: h, ...g } = c ?? {}, { className: _, ...v } = f ?? {}, { className: y, children: b, ...x } = m ?? {}, { className: S, ...C } = p ?? {}, { className: w, ...T } = d ?? {}, E = u !== null, D = u === void 0 ? b : () => u;
	return /* @__PURE__ */ r(t.Root, {
		...g,
		className: e("grid gap-2", h),
		max: s,
		value: l,
		children: o === "top" ? /* @__PURE__ */ i(n, { children: [(a || E) && /* @__PURE__ */ i("div", {
			className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3",
			children: [a && /* @__PURE__ */ r(t.Label, {
				className: _,
				...v,
				children: a
			}), E && /* @__PURE__ */ r(t.Value, {
				className: e(!a && "col-start-2", y),
				...x,
				children: D
			})]
		}), /* @__PURE__ */ r(t.Track, {
			className: S,
			...C,
			children: /* @__PURE__ */ r(t.Indicator, {
				className: w,
				...T
			})
		})] }) : /* @__PURE__ */ i("div", {
			className: "grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3",
			children: [
				a && /* @__PURE__ */ r(t.Label, {
					className: _,
					...v,
					children: a
				}),
				/* @__PURE__ */ r(t.Track, {
					className: e(!a && E && "col-start-1 col-end-3", !a && !E && "col-start-1 col-end-4", a && !E && "col-start-2 col-end-4", S),
					...C,
					children: /* @__PURE__ */ r(t.Indicator, {
						className: w,
						...T
					})
				}),
				E && /* @__PURE__ */ r(t.Value, {
					className: e(!a && "col-start-3", y),
					...x,
					children: D
				})
			]
		})
	});
}
//#endregion
export { a as ProgressBar };
